import React from 'react';
import {Textarea} from 'components/vitrade-forms/common';
import {SubCategorySelectorInput} from 'components/vitrade-forms';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {toastr} from 'react-redux-toastr';
import {Businesses} from 'api';
import {connect} from 'react-redux';

class PostDemandContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      categoryIds: [],
      content: '',
      isSubmit: false
    };
    this.props.validators['formDemand'] = [];
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.selectCategories = this.selectCategories.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  validateSubmitForm() {
    let isValid = true;
    this.props.validators['formDemand'].map(validator => {
      if (isValid) {
        isValid = validator.validate();
      } else {
        validator.validate();
      }
    });
    if (this.state.categoryIds.length === 0) {
      toastr.error('Lỗi!', 'Bạn vui lòng chọn ít nhất một nhóm sản phẩm cho sản phẩm hiện tại');
      return false;
    }
    if (!isValid) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }
    return isValid;
  }

  selectCategories(value) {
    let categoryIds = [];
    value.map(item => {
      categoryIds.push(item.value);
    });
    this.setState({categoryIds});
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      const {categoryIds, content} = this.state;
      const data = {
        categoryIds,
        content
      };
      this.setState({isSubmit: true});
      Businesses.actions.createDemand.request({id: this.props.myBusinesses.id}, {data}).then(response => {
        this.setState({isSubmit: false, content: '', categoryIds: []});
        toastr.success('Thành công!', 'Chào hàng/Yc báo giá thành công.');
      }).catch(error => {
        this.setState({isSubmit: false});
      });
    }
  }

  render() {
    const {isSubmit, content} = this.state;
    return (
      <form className="form-post-demand" onSubmit={this.onSubmit} noValidate>
        <Textarea type="text" placeholder="Nhập nội dung..."
          className="wrap-product-des"
          inputClassName="product-des-input"
          iconFontSet="glyphicon"
          iconClassName="glyphicon-user"
          onChange={this.onChange}
          name="content"
          value={content}
          required={true}
          bindValidator={this} channel="formDemand"
          errorMessage="Bạn vui lòng nhập nội dung"
        />
        <SubCategorySelectorInput label="Chọn nhóm sản phẩm" onChange={this.selectCategories}/>
        <div className="form-post-demand-btn-wrap">
          <LaddaButton className="post-demand-btn" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Đăng</LaddaButton>
        </div>
      </form>
    );
  }
}

PostDemandContent.defaultProps = {
  validators: {}
};

const mapStateToProp = (state) => {
  return {
    myBusinesses: state.myBusinesses.mainBusiness
  };
};

export default connect(mapStateToProp)(PostDemandContent);



// WEBPACK FOOTER //
// ./components/my-business/sub-view/post-demand-content/PostDemandContent.jsx